import BranchDeepLinksScript from '@Analytics/BranchDeepLinksScript';
import QuizLayout from '@cont/DST/Layout';
import setupInitialProps from '@utils/setupInitialProps';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { useRouter } from 'next/router';
import useSetMetaInfo from '@cont/DST/useSetMetaInfo';
import { handleDSTRedirectAndFetch } from '@cont/DST/utils';
import { emptyObject } from '@constants/empty';
import { getIsSubscribedToGoal } from '@selectors/subscription';
import { getDSTEndpoint } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/apiHelper';
import isEmptyObject from '@utils/isEmptyObject';
import { redirectToRoute } from '@utils/route';
import { getDefaultHost } from '@utils/api-helper/host';
import { simpleFetch as fetcher } from '@api/fetchers';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const DefaultHost = getDefaultHost();

const QuizInfo = ({ quizInfo, classPreference, attemptsInfo, goalInfo }) => {
  const { query } = useRouter();
  const { goalUID, goalSlug } = query;

  useSetMetaInfo({ quizInfo, classPreference, attemptsInfo });

  const goalName = goalInfo?.name;
  const metaTitle = `${goalName} Scholarship Test for Learners`;
  const metaDescription = `Take the scholarship test for ${goalName} to assess preparation level, identify strengths, and explore learning opportunities.`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${goalUID}/scholarship-test`;

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        canonical={canonicalURL}
        openGraph={{
          title: metaTitle,
          description: metaDescription,
          url: canonicalURL
        }}
      />
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalURL} />
      </Head>
      <BranchDeepLinksScript />
    </>
  );
};

QuizInfo.pageInfo = {
  name: 'Daily Scholarship Test',
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true
  }
};

QuizInfo.getInitialProps = setupInitialProps(
  async ({ store, query, isServer, res }) => {
    const { goalUID, goalSlug } = query;
    const { auth } = store.getState();
    const { isLoggedIn, me, accessToken } = auth || emptyObject;

    const goalInfo = store.getState().topologies?.data[goalUID] || {};
    const dstInfo = await fetcher(`${DefaultHost}${getDSTEndpoint(goalUID)}`);

    if (isEmptyObject(dstInfo)) {
      return redirectToRoute(isServer, res, '/');
    }

    if (isLoggedIn) {
      const isPlusUser = getIsSubscribedToGoal(goalUID)(store.getState());
      const { quizInfo, classPreference, attemptsInfo } =
        await handleDSTRedirectAndFetch({
          isPlusUser,
          goalUID,
          goalSlug,
          accessToken,
          searchToken: me.searchJwtToken,
          isServer,
          res
        });

      return {
        quizInfo,
        classPreference,
        attemptsInfo,
        goalInfo
      };
    }
    return { goalInfo };
  },
  QuizInfo.pageInfo
);

QuizInfo.Layout = QuizLayout;

export default QuizInfo;
QuizInfo.Wrapper = PageReduxProvider;
